module.exports = __webpack_public_path__ + "img/05_Module-2@2x.f20e80e7.jpg";